import React from 'react'
import blog1 from "../../Images/blog1image.jpg"
import Sidebar from '../../commanfile/Sidebar'

export const Blog1 = () => {
  return (
    <div className="lg:px-20 mx-auto py-2 mb-3">
      <div className='md:flex mb:6'>
        <div className='pt-6 sticky top-0 md:h-screen md:w-full w-[50%]'>
          <Sidebar />
        </div>
        <div className=''>
          <div className="mx-auto py-3 px-4 md:px-3">
            <div className="">
              <img src={blog1} className=" rounded-xl py-3 lg:h-[500px] md:h-[350px] h-[250px] w-full  "></img>
            </div>

            <div className="py-2">
              <p className="text-[#469B8F] font-roboto text-3xl font-bold uppercase underline leading-relaxed" >Understanding Psychiatry: Breaking Stigma and Building Mental Wellness</p>
              <p className=" font-roboto text-xl  py-4">Psychiatry is one of the most important but often misunderstood branches of medicine. It focuses on the diagnosis, treatment, and prevention of mental health conditions that affect how people think, feel, and behave. From anxiety and depression to schizophrenia, bipolar disorder, and dementia, psychiatry helps individuals across all stages of life—from children to the elderly—regain stability and improve their quality of living.</p>
            </div>
            <div className="">
              <p className="text-[#469B8F] font-roboto font-semibold   text-2xl pt-2 uppercase">Why Psychiatry Matters ?</p>
              <p className="font-roboto text-xl  py-2">Mental health is just as vital as physical health, yet many people hesitate to seek psychiatric care due to stigma, myths, or fear of being judged. In reality, psychiatric interventions can provide life-changing support by:</p>
              <ul className="font-roboto text-lg  py-2 list-disc list-inside  px-6">
                <li className="">
                  Helping individuals cope with emotional distress.
                </li>
                <li>
                  Improving daily functioning at work, school, and home.
                </li>
                <li>
                  Reducing risks associated with untreated mental illness, such as substance abuse or suicide.
                </li>
                <li>
                  Enhancing overall well-being and relationships.</li>
              </ul>

            </div>
            <div className="">
              <p className="text-[#469B8F] font-roboto font-semibold   text-2xl pt-2 uppercase">Common Conditions Addressed in Psychiatry</p>
              <p className="font-roboto text-lg  py-2 list-disc "> Psychiatrists manage a wide variety of mental health conditions, including:</p>
              <ul className="font-roboto text-lg py-2 list-disc list-inside  px-6">
                <li><span className="font-bold text-[#469B8F]">
                  Anxiety Disorders: </span> Persistent worry, panic attacks, phobias.
                </li>
                <li><span className="font-bold text-[#469B8F]">
                  Depression: </span> Prolonged sadness, lack of interest, hopelessness.
                </li>
                <li><span className="font-bold text-[#469B8F]">
                  Bipolar Disorder: </span> Extreme mood swings from highs (mania) to lows (depression).
                </li>
                <li><span className="font-bold text-[#469B8F]">	Schizophrenia and Psychosis:</span> Disrupted thoughts, hallucinations, delusions.</li>
                <li><span className="font-bold text-[#469B8F]">	Addiction and Substance Use Disorders: </span> Alcohol, nicotine, and drug dependence.</li>
                <li><span className="font-bold text-[#469B8F]">Dementia and Geriatric Psychiatry: </span> Memory loss, behavioral changes in old age.</li>
                <li> <span className="font-bold text-[#469B8F]">Child and Adolescent Disorders:</span> ADHD, autism spectrum, learning difficulties.</li>
              </ul>
            </div>
            <div className="">
              <p className="text-[#469B8F] font-roboto font-semibold   text-2xl pt-2 uppercase">How Psychiatry Helps ?</p>
              <p>Psychiatric care isn’t just about “medications.” It’s a holistic approach that may include:</p>
              <ul className="font-roboto text-lg py-2 list-disc list-inside  px-6">
                <li>
                  <span className="font-bold text-[#469B8F]">Counseling and Psychotherapies: </span> Talking therapies such as CBT, family therapy.</li>
                <li>
                  <span className="font-bold text-[#469B8F]"> Medications:</span>
                  When necessary, safe prescriptions to stabilize mood, sleep, or thought patterns.</li>
                <li>
                  <span className="font-bold text-[#469B8F]"> Lifestyle Guidance:</span>
                  Sleep hygiene, stress management, and coping skills.</li>
                <li>
                  <span className="font-bold text-[#469B8F]">Community Support: </span>	De-addiction programs, rehabilitation, and group therapies.</li>
                <li>
                  <span className="font-bold text-[#469B8F]">  Brain Stimulation Techniques:</span>
                  Treatments like Electroconvulsive Therapy (ECT) and Transcranial Magnetic Stimulation (TMS) for severe cases.
                </li>
              </ul>
            </div>
            <div className="">
              <p className="text-[#469B8F] font-roboto font-semibold   text-2xl pt-2 uppercase">Overcoming Myths and Stigma</p>
              <p>Despite scientific progress, myths around psychiatry persist. Some believe psychiatric problems are a sign of weakness or “madness.” Others think only “severe” cases need a psychiatrist. The truth is: mental health conditions are common and treatable, just like diabetes or hypertension. Seeking help early prevents complications and supports long-term recovery.</p>

              <p className="text-[#469B8F] font-roboto font-semibold   text-2xl pt-2 uppercase">
                When to Consult a Psychiatrist
              </p>
              <p>
                You should consider consulting a psychiatrist if you experience
              </p>

              <ul className="font-roboto text-lg py-2 list-disc list-inside  px-6">
                <li>Persistent sadness, anxiety, or irritability.</li>
                <li> Difficulty sleeping, concentrating, or managing daily tasks.</li>
                <li>
                  Unexplained physical symptoms like headaches and fatigue linked to stress.</li>
                <li>	Changes in behavior, memory, or thinking.</li>
                <li>
                  Thoughts of self-harm or substance misuse.
                </li>
              </ul>
            </div>
            <div className="">
              <p className="text-[#469B8F] font-roboto font-semibold   text-2xl pt-2 uppercase">Moving Toward Mental Wellness</p>
              <p className="font-roboto text-xl  py-4">Psychiatry is not about labeling people—it’s about helping them heal, adapt, and thrive. By breaking the stigma and understanding the value of psychiatric care, society can move closer to embracing mental health as an essential part of overall health.</p>

            </div>
          </div>

        </div>
        {/* <div className="mx-auto py-3 px-7">
            <div className="">
              <img src={blog1} className=" rounded-2xl py-3 h-[800px] w-full "></img>
            </div>

            <div className="py-2">
              <p className="text-[#469B8F] font-roboto text-3xl font-bold uppercase underline leading-relaxed" >Understanding Psychiatry: Breaking Stigma and Building Mental Wellness</p>
              <p className=" font-roboto text-xl  py-4">Psychiatry is one of the most important but often misunderstood branches of medicine. It focuses on the diagnosis, treatment, and prevention of mental health conditions that affect how people think, feel, and behave. From anxiety and depression to schizophrenia, bipolar disorder, and dementia, psychiatry helps individuals across all stages of life—from children to the elderly—regain stability and improve their quality of living.</p>
            </div>
            <div className="">
              <p className="text-[#469B8F] font-roboto font-semibold   text-2xl pt-2 uppercase">Why Psychiatry Matters ?</p>
              <p className="font-roboto text-xl  py-2">Mental health is just as vital as physical health, yet many people hesitate to seek psychiatric care due to stigma, myths, or fear of being judged. In reality, psychiatric interventions can provide life-changing support by:</p>
              <ul className="font-roboto text-lg  py-2 list-disc list-inside  px-6">
                <li className="">
                  Helping individuals cope with emotional distress.
                </li>
                <li>
                  Improving daily functioning at work, school, and home.
                </li>
                <li>
                  Reducing risks associated with untreated mental illness, such as substance abuse or suicide.
                </li>
                <li>
                  Enhancing overall well-being and relationships.</li>
              </ul>

            </div>
            <div className="">
              <p className="text-[#469B8F] font-roboto font-semibold   text-2xl pt-2 uppercase">Common Conditions Addressed in Psychiatry</p>
              <p className="font-roboto text-lg  py-2 list-disc "> Psychiatrists manage a wide variety of mental health conditions, including:</p>
              <ul className="font-roboto text-lg py-2 list-disc list-inside  px-6">
                <li><span className="font-bold text-[#469B8F]">
                  Anxiety Disorders: </span> Persistent worry, panic attacks, phobias.
                </li>
                <li><span className="font-bold text-[#469B8F]">
                  Depression: </span> Prolonged sadness, lack of interest, hopelessness.
                </li>
                <li><span className="font-bold text-[#469B8F]">
                  Bipolar Disorder: </span> Extreme mood swings from highs (mania) to lows (depression).
                </li>
                <li><span className="font-bold text-[#469B8F]">	Schizophrenia and Psychosis:</span> Disrupted thoughts, hallucinations, delusions.</li>
                <li><span className="font-bold text-[#469B8F]">	Addiction and Substance Use Disorders: </span> Alcohol, nicotine, and drug dependence.</li>
                <li><span className="font-bold text-[#469B8F]">Dementia and Geriatric Psychiatry: </span> Memory loss, behavioral changes in old age.</li>
                <li> <span className="font-bold text-[#469B8F]">Child and Adolescent Disorders:</span> ADHD, autism spectrum, learning difficulties.</li>
              </ul>
            </div>
            <div className="">
              <p className="text-[#469B8F] font-roboto font-semibold   text-2xl pt-2 uppercase">How Psychiatry Helps ?</p>
              <p>Psychiatric care isn’t just about “medications.” It’s a holistic approach that may include:</p>
              <ul className="font-roboto text-lg py-2 list-disc list-inside  px-6">
                <li> 
                  <span className="font-bold text-[#469B8F]">Counseling and Psychotherapies: </span> Talking therapies such as CBT, family therapy.</li>
                <li>
                  <span className="font-bold text-[#469B8F]"> Medications:</span>
                  When necessary, safe prescriptions to stabilize mood, sleep, or thought patterns.</li>
                <li>
                  <span className="font-bold text-[#469B8F]"> Lifestyle Guidance:</span>
                  Sleep hygiene, stress management, and coping skills.</li>
                <li>
                  <span className="font-bold text-[#469B8F]">Community Support: </span>	De-addiction programs, rehabilitation, and group therapies.</li>
                <li>
                  <span className="font-bold text-[#469B8F]">  Brain Stimulation Techniques:</span>
                 Treatments like Electroconvulsive Therapy (ECT) and Transcranial Magnetic Stimulation (TMS) for severe cases.
                </li>
              </ul>
            </div>
            <div className="">
              <p className="text-[#469B8F] font-roboto font-semibold   text-2xl pt-2 uppercase">Overcoming Myths and Stigma</p>
              <p>Despite scientific progress, myths around psychiatry persist. Some believe psychiatric problems are a sign of weakness or “madness.” Others think only “severe” cases need a psychiatrist. The truth is: mental health conditions are common and treatable, just like diabetes or hypertension. Seeking help early prevents complications and supports long-term recovery.</p>

              <p className="text-[#469B8F] font-roboto font-semibold   text-2xl pt-2 uppercase">
                When to Consult a Psychiatrist
              </p>
              <p>
                You should consider consulting a psychiatrist if you experience
              </p>

              <ul className="font-roboto text-lg py-2 list-disc list-inside  px-6">
                <li>Persistent sadness, anxiety, or irritability.</li>
                <li> Difficulty sleeping, concentrating, or managing daily tasks.</li>
                <li>
                  Unexplained physical symptoms like headaches and fatigue linked to stress.</li>
                <li>	Changes in behavior, memory, or thinking.</li>
                <li>
                  Thoughts of self-harm or substance misuse.
                </li>
              </ul>
            </div>




            <div className="">
              <p className="text-[#469B8F] font-roboto font-semibold   text-2xl pt-2 uppercase">Moving Toward Mental Wellness</p>
              <p className="font-roboto text-xl  py-4">Psychiatry is not about labeling people—it’s about helping them heal, adapt, and thrive. By breaking the stigma and understanding the value of psychiatric care, society can move closer to embracing mental health as an essential part of overall health.</p>

            </div>
          </div> */}

      </div>
    </div>
  )

}
